<div class="em-settings-schedules">
    <router-outlet></router-outlet>
</div>